export const kendoCalendarMonthNum = 6;
export const eventFilterTerms = ["kendo", "fka"];
